import styled from 'styled-components';

import { ART_STYLE, COLORS, SPACE } from '../../../../theme/tokens';
import { Pill } from '../MascotPicker/MascotPicker.styles';

/** The list shares the mascot picker's material, so the two read as one row of choices. */
export {
  Check,
  MenuPanel,
  Option,
  OptionCopy,
  OptionHint,
  OptionLabel,
  PillLabel,
} from '../MascotPicker/MascotPicker.styles';

/** The mascot picker's pill with the "Art style" chip's padding: an icon, not an avatar, leads it. */
export const StylePill = styled(Pill)`
  padding: ${SPACE[4]} ${SPACE[8]} ${SPACE[4]} ${SPACE[12]};
`;

export const PillName = styled.span`
  color: ${COLORS.textBright};
`;

/** A style's thumbnail in the list (its newest hero sample), or its palette icon while it has none. */
export const Thumb = styled.span`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: ${ART_STYLE.MASCOT_MENU_AVATAR_PX}px;
  height: ${ART_STYLE.MASCOT_MENU_AVATAR_PX}px;
  border-radius: ${SPACE[8]};
  overflow: hidden;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.surfaceInset};
  color: ${COLORS.textMuted};

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
